import ApiCompany, { Social } from 'types/api/Company';

import FileUpload from 'models/FileUpload';
import Model from 'models/Model';
import Opinion from 'models/Opinion';

export enum CompanyDetailsDataTypes {
    methodology = 'methodology',
    howHelp = 'howHelp',
    aboutUs = 'aboutUs',
}

export interface CompanyDetailsData {
    id?: string;
    type: CompanyDetailsDataTypes;
    content: string;
    order: number;
    courseId?: string;
}

export interface CompanyDetails {
    methodology: CompanyDetailsData[];
    howHelp: CompanyDetailsData[];
    aboutUs: CompanyDetailsData[];
    forWhom?: CompanyDetailsData[];
    program?: CompanyDetailsData[];
    whatGet?: CompanyDetailsData[];
}

export default class Company implements Model {
    id: string;
    name: string;
    slug: string;
    description: string;
    socials: Record<Social, string>;
    image: FileUpload;
    images: FileUpload[];
    details: CompanyDetails;
    opinions: Opinion[];
    partnerPlan: string;
    newCompanyPage: boolean;

    constructor(data: ApiCompany) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.slug = data.slug;
        this.image = data.image && new FileUpload(data.image);
        this.images = Array.isArray(data.images) && data.images.map(image => new FileUpload(image));
        this.socials = data.socials;
        this.partnerPlan = data.partnerPlan;
        this.details = data.details;
        this.opinions = data.opinions;
        this.newCompanyPage = data.newCompanyPage;
    }
}
